import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
	Row, Col, Tab, Panel, NavItem,
	Nav, ListGroup, ListGroupItem,
	Modal,
} from 'react-bootstrap';
import {Link} from 'react-router';
import {
	ClientDetails, RecentlyViewedClients,
	RecentlyViewedMaps, MapList, MapSearchList
} from '../';
import * as Permissions from 'permissions';
import * as Actions from 'actions';

class DashboardSummary extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			currentTab : 'first'
		}

		this.populated_clients;

		this.handleSelectTab = this.handleSelectTab.bind(this);
		this.handleSelectClient = this.handleSelectClient.bind(this);
	}

	handleSelectTab(eventKey) {
    this.setState({currentTab : eventKey});
  }

  handleSelectClient(event) {
  	this.props.selectClient(event.currentTarget.id)
  	this.setState({view_client_details : true})
  }

	render() {
		let {user} = this.props.users;

		return (
			<div className='dashboard-summary-container animated fadeInUp'>
				<Modal
					className='client-details-container'
      		show={this.state.view_client_details}
      		onHide={() => {this.setState({view_client_details : !this.state.view_client_details})}}
      		bsSize="sm">
      		{(() => {
      			if(user && user.recently_viewed_clients)
      				return (
      					<div className="bg-dark pt-sm pb-sm pr-sm pl-sm">
	      					<ClientDetails
				    				client={user.recently_viewed_clients.find(c => {
				    					return c._id === this.props.clients.selected_client_id
				    				})}
				    			/>
			    				<Link
			    					to={`/client/${this.props.clients.selected_client_id}`}
			    					className='client-details-button btn btn-primary btn-block'>
			    					Client Details
			    				</Link>
		    				</div>
      				)
      		})()}
      	</Modal>
	        <Tab.Container
	        	id='tabs-with-dropdown'
	        	defaultActiveKey='third'>
							<div>
	              <Nav bsStyle='tabs' onSelect={this.handleSelectTab}>
									<NavItem eventKey='third'>
										<i className="fa fa-search"></i> Search Maps
									</NavItem>
									<NavItem eventKey='fourth'>
										<i className="fa fa-star-o"></i> Favorite Maps
									</NavItem>
	                <NavItem eventKey='first'>
	                  <i className="fa fa-eye"></i> Viewed Maps
	                </NavItem>
	                {(() => {
	                	if(this.props.hasPermission(Permissions.VIEW_CLIENTS)) {
	                		return (
	                			<NavItem eventKey='second'>
				                  <i className="fa fa-user-o"></i> Viewed Clients
				                </NavItem>
	                			)
	                	}
	                })()}
	              </Nav>
	              <Tab.Content animation>
	               	<Tab.Pane eventKey='first'>
										<MapList maps={user.recently_viewed} />
	                </Tab.Pane>
	                <Tab.Pane eventKey='second'>
	                  <RecentlyViewedClients
	                  	recently_viewed_clients={
	                  		!user.recently_viewed_clients ?
	                  		null : user.recently_viewed_clients
	                  	}
	                  	handleSelectClient={this.handleSelectClient}
	                  />
	                </Tab.Pane>
									<Tab.Pane eventKey='third'>
										<MapSearchList />
									</Tab.Pane>
									<Tab.Pane eventKey='fourth'>
										<MapList maps={user.favorites} />
									</Tab.Pane>
	              </Tab.Content>
							</div>
	        </Tab.Container>
        </div>
		)
	}
}

let mapStateToProps = ({ clients, users }) => ({ clients, users });

export default connect(mapStateToProps, Actions)(DashboardSummary);



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboardSummary.js